/* Package JSON Import will be here */
import React from "react";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner";
/* Project Import will be here */

const SpinnerAppLoading = (props) => {
    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale),
    }));
    return (
        <div id="overlay">
            <Spinner message={translate("common.loading.appLoading")} />
        </div>
    )
}

export default SpinnerAppLoading;